import type { OpenAPI } from "simplydo/interfaces";

export const businessTypeOptions = [
  { key: "public", value: "public", text: "Public Sector" },
  { key: "private", value: "private", text: "Private Sector" },
  { key: "notForProfit", value: "notForProfit", text: "Not For-Profit" },
  { key: "academic", value: "academic", text: "Academic" },
];

export const businessSizeOptions = [
  { key: "micro", value: "micro", text: "Micro <10 Employees" },
  { key: "small", value: "small", text: "Small <50 Employees" },
  { key: "medium", value: "medium", text: "Medium <250 Employees" },
  { key: "large", value: "large", text: "Large >250 Employees" },
];

export const businessStatusOptions = [
  { key: "preStartup", value: "preStartup", text: "Pre-start-up" },
  { key: "startup", value: "startup", text: "Start up < 1 year" },
  {
    key: "established_small",
    value: "established_small",
    text: "Established 1 - 5 years",
  },
  {
    key: "established_medium",
    value: "established_medium",
    text: "Established 6 - 10 years",
  },
  {
    key: "established_large",
    value: "established_large",
    text: "Established > 10 years",
  },
];

export const accreditations = [
  { key: "cyberEssentialsPlus", text: "Cyber Essentials Plus" },
  { key: "cyberEssentials", text: "Cyber Essentials" },
  { key: "ISO27001", text: "ISO 27001" },
  { key: "ISO9001", text: "ISO 9001" },
  { key: "FENSA", text: "FENSA" },
  { key: "SSIP", text: "SSIP" },
  { key: "MCS", text: "MCS" },
  { key: "PAS2030", text: "PAS 2030" },
  { key: "livingWageEmployer", text: "Living Wage Employer" },
  { key: "other", text: "Other" },
];

export const ideaTemplateHasBusinessProfile = (
  ideaTemplate: OpenAPI.Schemas["IdeaTemplate"] | undefined | null,
) => {
  if (!ideaTemplate?.body) return false;
  return ideaTemplate.body.some(
    (section) => section.type === "businessProfile",
  );
};
